import { createContext, useContext } from "react";
export var AuthContext = createContext({
    enableUxf: false,
    authenticated: false,
    loginUrl: "",
});
export function useAuth() {
    return useContext(AuthContext);
}
